<div class="form-summary">
  <label class="col-md-6 col-xs-12"><ng-content></ng-content></label>
    <span class="form-summary-item col-md-6 col-xs-12">{{phoneDisplay}}</span>
</div>
